/**
    Compensafe Loading Message

    Depends On:
    JQuery 1.7.2
    JQueryUI 1.8.19

    This plugin will display a loading message consisting of a floating box and an animated gif
    indicating to the user that data is being loaded from the server.


    Options:
        startHidden: if true then plugin will hide target when created.

    Public API:
        show(): show the loading message
        
        hide(): hide the loading message

 */
(function($)
{
    $.widget("compensafe.loadingMsg",
    {
        options:
        {
            startHidden: true
        },
        _create: function()
        {
            var self=this;
            var o=self.options;

            self._createPrefix();

            self.element.addClass('compensafe-loadingmsg');
            self.element.addClass('ui-widget');
            self.element.addClass('ui-widget-content');
            self.element.addClass('ui-corner-all');
            
            if(self.options.startHidden===true)
            {
                self.hide();
            }
            
            var html=
            'Loading...' +
            '<div class="compensafe-loadingmsg-img"></div>';

            self.element.append(html);
        },
        _createPrefix: function()
        {
            var self=this;
            // if element has an id, then use that for prefix
            var id=self.element.attr('id');
            if (id==null)
            {
                id=self.widgetBaseClass+parseInt(Math.random()*10000);
            }

            self.options.prefix=id+'-';
        },
        _id: function(id)
        {
            var self=this;
            return self.options.prefix+id;
        },
        _setOption: function(key, value)
        {
        },
        destroy: function()
        {
            // In jQuery UI 1.8, you must invoke the destroy method from the base widget
            $.Widget.prototype.destroy.call(this);
            // In jQuery UI 1.9 and above, you would define _destroy instead of destroy and not call the base method
        },
        show: function()
        {
            var self=this;
            self.element.show();
        },
        hide: function()
        {
            var self=this;
            self.element.hide();
        }
    });
})(jQuery);